import { isArray } from "lodash";
import { ApplicationState } from "../index";

export function getById(id: string) {
  return (state: ApplicationState) => {
    if ( isArray(state.hashedHotCard.data) ) {
      return state.hashedHotCard.data.find((x) => x.id === id)
    }
    else {
      return state.hashedHotCard.data
    }
  }
} 